import { SeedPlusIcon } from './SeedPlusIcon';

/**
 * author: Jeff Anders
 * id 06E48E27-F112-4D54-ABE4-95FB216A5DEB
 * name seed-plus
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seed-plus.svg
 * tags
 * - Agriculture 
 * - Nature 
 */
export const SeedAddIcon = SeedPlusIcon;
export default SeedAddIcon